// Error shapes per spec §4.10. Every partner-initiated mutation that affects an external
// system follows this contract. The dashboard renders a single error dialog component
// driven by these types.

export interface WriteFailedError {
	__type: "WriteFailedError";
	code: WriteFailedErrorCode;
	userMessage: string;
	retryable: boolean;
}

export type WriteFailedErrorCode =
	| "RECURLY_DECLINED"
	| "RECURLY_UNAVAILABLE"
	| "RECURLY_METADATA_FAILED"
	| "EMAIL_TAKEN"
	| "EMAIL_INVALID"
	| "SLUG_TAKEN"
	| "SLUG_INVALID"
	| "ACCOUNT_NOT_OWNED"
	| "PENDING_EMAIL_CHANGE_EXISTS"
	| "PENDING_OWNER_INVITE_EXISTS"
	| "GENERIC";

export interface PaymentMethodRequiredError {
	__type: "PaymentMethodRequiredError";
	code: "PAYMENT_METHOD_REQUIRED";
	userMessage: string;
	retryable: false;
}

export interface WriteInFlightError {
	__type: "WriteInFlightError";
	code: "WRITE_IN_FLIGHT";
	userMessage: string;
	retryable: false;
}

export type PartnerWriteError =
	| WriteFailedError
	| PaymentMethodRequiredError
	| WriteInFlightError;

export const isWriteFailedError = (
	err: PartnerWriteError,
): err is WriteFailedError => err.__type === "WriteFailedError";

export const isPaymentMethodRequiredError = (
	err: PartnerWriteError,
): err is PaymentMethodRequiredError =>
	err.__type === "PaymentMethodRequiredError";

export const isWriteInFlightError = (
	err: PartnerWriteError,
): err is WriteInFlightError => err.__type === "WriteInFlightError";
